var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDownloadBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.59 6.75H10V1.75C10 1.2 9.55 0.75 9 0.75H5C4.45 0.75 4 1.2 4 1.75V6.75H2.41C1.52 6.75 1.07 7.83 1.7 8.46L6.29 13.05C6.68 13.44 7.31 13.44 7.7 13.05L12.29 8.46C12.92 7.83 12.48 6.75 11.59 6.75ZM0 16.75C0 17.3 0.45 17.75 1 17.75H13C13.55 17.75 14 17.3 14 16.75C14 16.2 13.55 15.75 13 15.75H1C0.45 15.75 0 16.2 0 16.75Z",
    fill: "#0065B3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownloadBlue);
export default __webpack_public_path__ + "static/media/icon-download-blue.ef7e277f5dd045047f4fcf62fdf44de7.svg";
export { ForwardRef as ReactComponent };